// extracted by mini-css-extract-plugin
export var arrows = "_5s-5";
export var decrementer = "_5s-9";
export var disabled = "_5s-3";
export var error = "_5s-1";
export var hiddenText = "_5s-a";
export var incrementer = "_5s-8";
export var input = "_5s-7";
export var inputWrapper = "_5s-0";
export var readonly = "_5s-2";
export var regular = "_5s-6";
export var small = "_5s-4";